export enum appPath {
  home = '/',
  about = '/about',
  aboutPlan = '/about#計畫簡介',
  aboutOrganization = '/about#組織架構',
  aboutMember = '/about#歷屆名單',
  career = '/career',
  careerPersonalization = '/career#個人指導',
  careerInterview = '/career#職涯訪談',
  careerCompany = '/career#公司實習',
  courses = '/courses',
  recruit = '/recruit',
  faq = '/faq',
  alumni = '/alumni',
  alumniSenior = '/alumni#學長姐怎麼看',
  alumniLeader = '/alumni#領導者怎麼看',
  alumniJunior = '/alumni#學員怎麼看',
  plan = '/plan',
  projects = '/projects#ps',
  visitation = '/visitation',
  apply = '/apply',
  applySteps = '/apply/steps',
}
